"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperTokenLibraryCFASuperAppMock__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "_host",
                type: "address",
            },
            {
                internalType: "address",
                name: "defaultSender",
                type: "address",
            },
            {
                internalType: "address",
                name: "defaultReceiver",
                type: "address",
            },
            {
                internalType: "address",
                name: "defaultFlowOperator",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
        ],
        name: "authorizeFlowOperatorWithFullControl",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
        ],
        name: "createFlow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SuperTokenLibraryCFASuperAppMock__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_host, defaultSender, defaultReceiver, defaultFlowOperator, overrides) {
        return super.deploy(_host, defaultSender, defaultReceiver, defaultFlowOperator, overrides || {});
    }
    getDeployTransaction(_host, defaultSender, defaultReceiver, defaultFlowOperator, overrides) {
        return super.getDeployTransaction(_host, defaultSender, defaultReceiver, defaultFlowOperator, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SuperTokenLibraryCFASuperAppMock__factory = SuperTokenLibraryCFASuperAppMock__factory;
SuperTokenLibraryCFASuperAppMock__factory.bytecode = _bytecode;
SuperTokenLibraryCFASuperAppMock__factory.abi = _abi;
//# sourceMappingURL=SuperTokenLibraryCFASuperAppMock__factory.js.map